import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BackCircle from "../components/Buttons/BackCircle";
import HalfColumn from "../components/Column/HalfColumn";
import { NavBar } from "../components/NavBar";
import Row from "../components/Row/Row";
import Text from "../components/Text/Text";
import back_circle from "../imgs/back_circle.svg";
import collectible_icon from "./imgs/collectible_icon.svg";
import master_copy_icon from "./imgs/master_copy_icon.svg";

interface CreateNFTOptionProps {
  theme: string;
  toggleTheme: () => void;
}

const CreateNFTContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: #000d30;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const Card = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 20vh;
  min-width: 10vw;
  padding-inline: 3%;
  padding-top: 3%;
  border: 1px solid #ffffff90;
  border-radius: 15px;
  align-self: stretch;

  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
`;

export const CreateNFTOptionPage: React.FC<CreateNFTOptionProps> = ({
  theme,
  toggleTheme,
}) => {
  const navigate = useNavigate();

  const onBackClick = () => {
    navigate(-1);
  };

  const onCollectibleClick = () => {
    navigate("/upload_file", { state: { masterCopy: false } });
  };

  const onMasterCopyClick = () => {
    navigate("/upload_file", { state: { masterCopy: true } });
  };
  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} hideNavLinks={true} />

      <CreateNFTContainer>
        <HalfColumn
          style={{
            textAlign: "center",
            marginTop: "5%",
            minHeight: "70vh",
            justifyContent: "space-evenly",
          }}
        >
          <div style={{ position: "relative"}}>
            <BackCircle bg={back_circle} onClick={onBackClick} />

            <Text bold={true} size={"32px"} style={{paddingInline: '10%'}}>
              Please select the NFT type you would like to create:
            </Text>
          </div>

          <Row style={{ width: "100%" }} align={"space-evenly"} gap={"5%"}>
            <Card onClick={onMasterCopyClick}>
              <img src={master_copy_icon} />
              <Text bold={true} size={'20px'}>Master Copy</Text>
              <Text>
                A 1 of 1 NFT, this NFT comes with a legal contract that gives
                commercial rights to the owner. You can create licenses for
                content creators using this NFT.
              </Text>
            </Card>

            <Card onClick={onCollectibleClick} >
              <img src={collectible_icon} />
              <Text bold={true} size={'20px'}>Collectibles NFT</Text>

              <Text>
                Up to 10,000 Unique NFTs, fans can support their favorite
                artists. There is no legal contract associated with this type of NFT.
              </Text>
            </Card>
          </Row>
        </HalfColumn>
      </CreateNFTContainer>
    </>
  );
};
